import React from 'react';
export function Footer() {
  return <footer className="bg-base py-8 border-t border-silver-light text-center px-4" data-id="element-128" data-mp="32wd2qgad7ltj">
      <div className="max-w-4xl mx-auto" data-id="element-129" data-mp="3gg0za3iktxxn">
        <p className="text-graphite-light text-sm" data-id="element-130" data-mp="3gh3ng3oilm9v">
          © 2026 Mindfulness &amp; Meditation Teacher Ready — All Rights Reserved.
        </p>
      </div>
    </footer>;
}